import React from 'react';
import UserDashboard from './UserDashboard';

const OrganizerDashboard = ({ user }) => {
  return <UserDashboard user={user} />;
};

export default OrganizerDashboard;
